module.exports = __webpack_public_path__ + "static/media/logos4.ea8c387a.png";